export const URL_SORT_ORDERS = { ascend: "asc", descend: "desc" };

export const TABLE_SORT_ORDERS = { asc: "ascend", desc: "descend" };

export const COLUMN_ADD_DIRECTION = { left: 0, right: 1 };

export const SELECT_ALL_ROWS_CALLOUT_DESKTOP_HEIGHT = 57;
export const SELECT_ALL_ROWS_CALLOUT_MOBILE_HEIGHT = 78;

export const COLUMN_FIXED_VALUES = { LEFT: "left", RIGHT: "right" };

export const TABLE_PAGINATION_HEIGHT = 64;
export const TABLE_DEFAULT_HEADER_HEIGHT = 40;
export const TABLE_ROW_HEIGHT = 52;
